import React from 'react';
import { Box, Button, Chip, Collapse, Typography } from '@mui/material';
import { useLanguage } from '../../contexts/LanguageContext';

export interface ActiveTableFilter {
  key: string;
  label: string;
  onDelete: () => void;
}

interface TableFilterPanelProps {
  id: string;
  open: boolean;
  fields: React.ReactNode;
  activeFilters: ActiveTableFilter[];
  onClear: () => void;
  onApply: () => void;
  error?: string;
  columns?: number;
}

/** Shared layout and actions for table filters. Pages own their filter values. */
const TableFilterPanel: React.FC<TableFilterPanelProps> = ({
  id, open, fields, activeFilters, onClear, onApply, error, columns = 4,
}) => {
  const { t } = useLanguage();

  return <>
    {activeFilters.length > 0 && <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap', mt: 1.5 }}>
      <Typography variant="caption" color="text.secondary">{t('debts.activeFilters')}</Typography>
      {activeFilters.map(filter => <Chip key={filter.key} size="small" label={filter.label} onDelete={filter.onDelete} sx={{ bgcolor: 'action.selected' }} />)}
    </Box>}
    <Collapse in={open}>
      <Box id={id} sx={{ mt: 2, p: 2, bgcolor: 'action.hover', border: '1px solid', borderColor: 'divider', borderRadius: 1.5 }}>
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, minmax(0, 1fr))', lg: `repeat(${columns}, minmax(0, 1fr))` }, gap: 1.5 }}>
          {fields}
        </Box>
        {error && <Typography role="alert" color="error.main" variant="body2" sx={{ mt: 1 }}>{error}</Typography>}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 1.5, flexWrap: 'wrap', mt: 2 }}>
          <Button variant="text" onClick={onClear}>{t('common.clearFilters')}</Button>
          <Button variant="contained" onClick={onApply}>{t('debts.showResults')}</Button>
        </Box>
      </Box>
    </Collapse>
  </>;
};

export default TableFilterPanel;
